import { render } from "./AssessementDetail.vue?vue&type=template&id=63963ce2"
import script from "./AssessementDetail.vue?vue&type=script&lang=js"
export * from "./AssessementDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__